import en from './locales/en/translation.json' with { type: 'json' }
import ja from './locales/ja/translation.json' with { type: 'json' }

export const i18nTranslations = {
  ja,
  en,
}
